import { render, staticRenderFns } from "./IconDownload.vue?vue&type=template&id=928443ea&scoped=true&"
import script from "./IconDownload.vue?vue&type=script&lang=js&"
export * from "./IconDownload.vue?vue&type=script&lang=js&"
import style0 from "./IconDownload.vue?vue&type=style&index=0&id=928443ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928443ea",
  null
  
)

export default component.exports